var _rect, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgButtonBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 84,
    viewBox: "0 0 203 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.585449,
    y: 0.916138,
    width: 202.171,
    height: 82.1678,
    rx: 41.0839,
    fill: "url(#paint0_linear_916_195035)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_916_195035",
    x1: 0.585449,
    y1: 83.084,
    x2: 158.719,
    y2: 83.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EF41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonBg);
export default __webpack_public_path__ + "static/media/button-bg.9fb7aff25502e0cb5ed46db235e75703.svg";
export { ForwardRef as ReactComponent };